<template>
  <div id="assets" ref="assets">
    <v-row>
      <v-col class="custom-card px-0 pa-0" v-bind:class="{ 'card-no-footer-height': !isListViewSelected,'relative-position': sitesLoaded && !currentSite.id }">
        <v-row v-if="sitesLoaded && !currentSite.id">
          <v-col class="no-sites-msg">
            <b>Add a site to your organization so that you may start adding assets (Configuration → Sites → Add Site).  Assets belong to one (and only one) Airfinder site.</b>
          </v-col>
        </v-row>
        <v-row class="mb-3" style="height: 60px;">
           <!-- search bar -->
           <search-bar class="mt-7" 
              v-if="((!getIsMobileIpadPortrait && !isSummaryViewSelected) || (getIsMobileIpadPortrait && isListViewSelected))" 
              @clearClicked="clearSearchClicked" 
              @onSearchBarKeyUp="searchTyped" 
              :searchText="searchTerm" 
              @searchText="searchBarFilter" 
              :cleanText="cleanText" 
              v-bind:class="{'only-search': getIsMobileIpadPortrait, 'search-with-menu': getIsMobileIpadPortrait && isListViewSelected}"
              :style="getIsMobileIpadPortrait && isListViewSelected ? 'width: calc(100% - 60px);' : ''" 
            />
            
            <v-col 
              :cols="getIsMobileIpadPortrait && isListViewSelected ? 'auto' : 8" 
              v-bind:class="{
                'col-12': (getIsMobileIpadPortrait && isListMapViewSelected) || isSummaryViewSelected,
                'd-flex': getIsMobileIpadPortrait && isListViewSelected,
                'align-center': getIsMobileIpadPortrait && isListViewSelected,
                'justify-end': getIsMobileIpadPortrait && isListViewSelected,
                'pa-0': getIsMobileIpadPortrait && isListViewSelected,
                'text-right': getIsMobileIpadPortrait && !isListViewSelected
              }"
            >
              <!-- Mobile menu - Always visible in mobile/tablet -->
              <v-menu v-if="getIsMobileIpadPortrait" 
                offset-y
                :nudge-right="-1"
                min-width="200"
                left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="btn-toggle mr-3"
                    :class="{'mt-4': !isListViewSelected, 'mt-4 ml-3': isListViewSelected}"
                    v-bind="attrs"
                    v-on="on"
                    depressed
                    small
                  >
                    <v-icon color="secondary" small class="mr-1">
                      {{ currentViewIcon }}
                    </v-icon>
                    <span class="toggle-map-list-label">{{ currentViewLabel }}</span>
                    <v-icon small>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="onSummaryTabSelected">
                    <v-list-item-icon>
                      <v-icon small>mdi-chart-bar</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('btn-header-option3') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="onListTabSelected">
                    <v-list-item-icon>
                      <v-icon  small>mdi-format-list-bulleted</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('btn-header-option1') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="goToMap" :disabled="!mapFiltersLoaded">
                    <v-list-item-icon>
                      <v-icon small>mdi-map</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('btn-header-option2') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>  
          
              <span v-show="!isSummaryViewSelected">
                  <div class="d-none d-sm-inline float-left mt-4">
                    <filter-form
                      v-if="(getIsMobileIpadPortrait === false)"
                      :filterFields="filters"
                      :searchApplied="filterApplied"
                      :searchText="searchTerm"
                      :savedFilterForm="activeFilter"
                      :cleanForm="cleanForm"
                      @saveFilter="saveFilterToFav"
                      @onSearchTyped="searchTyped"
                      @applyFilters="applyFilters"
                      @deselectFilter="deselectFavFilter"
                      ref="filterFormRef"
                    ></filter-form>
                  </div>
                  <div>
                    <div v-if="filterApplied && !hideTags" class="primary--text total-text mt-6">
                      <b>{{filteredTotalRows}}</b>
                      <span> ({{percentFilter}})</span>	 
                      {{$t('assets-page-of')}} {{ totalRows }} {{$t('assets-page-match-filter')}}
                    </div>
                    <div v-if="!filterApplied && !hideTags" class="primary--text total-text mt-6">
                      <b>{{ totalRows }}</b> {{$t('assets-page-assets-total')}}
                    </div>
                    <div v-if="hideTags" class="primary--text total-text">
                      <a @click="loadAllTags">{{$t('assets-page-search-all')}}</a>
                    </div>
                  </div>
              </span>        
              
            <v-btn-toggle
              v-if="!getIsMobileIpadPortrait"
              v-model="toggleOption"
              v-show="$route.meta.headerToggle"
              class="btn-toggle float-right mr-3 mt-4"
            >
            <v-btn :value="tabOptions.summary.id" @click="onSummaryTabSelected" depressed small>
                <v-icon color="secondary" small class="mr-1 ">
                  mdi-chart-bar
                </v-icon>
                <span class="toggle-map-list-label">{{ $t('btn-header-option3') }}</span>
              </v-btn>
              <v-btn :value="tabOptions.list.id" @click="onListTabSelected" depressed small>
                <v-icon color="secondary" small class="mr-1">
                  mdi-format-list-bulleted
                </v-icon>
                <span class="toggle-map-list-label">{{ $t('btn-header-option1') }}</span>
              </v-btn>
              <v-btn :value="tabOptions.listMap.id" @click="goToMap" depressed small class="show-map-btn" :disabled="!mapFiltersLoaded">
                <v-icon color="secondary" small class="mr-1 ">mdi-map</v-icon>
                <span class="toggle-map-list-label">{{ $t('btn-header-option2') }}</span>
              </v-btn>
            </v-btn-toggle>
            </v-col>
        </v-row>
        <v-row  v-if="getIsMobileIpadPortrait === false && !isSummaryViewSelected">
          <v-col :cols="getWindowWidth > iphone ? 7 : 1" class="filter-height">
            <div class="d-none d-sm-inline">
              <filters-saved
                ref="favFilters"
                :width="filtersWidth"
                :filters="favFilters"
                @applyFilter="applyFavFilter"
                @deleteFilter="deleteFavFilter"
              ></filters-saved>
            </div>
          </v-col>
          <v-col :cols="getWindowWidth > iphone ? 5 : 11" class="pb-0 mb-4">
            <div class="mr-3 right-btn-container">
              <v-btn v-if="getWindowWidth > iphone" id="import-asset" min-width="50" height="32" @click="importDevice" :depressed="true" class="primary--text font-weight-bold mr-3" v-bind:class="{'px-0': (sm > getWindowWidth)}" color="primaryLight">
                <v-icon v-if="sm > getWindowWidth"> mdi-import </v-icon>
                <span v-if="sm <= getWindowWidth">{{$t('assets-page-import-device')}}</span>
              </v-btn>
              <v-btn id="add-asset" min-width="50" height="32" @click="createDevice" :depressed="true" class="primary--text font-weight-bold" v-bind:class="{'px-0': (sm > getWindowWidth)}" color="primaryLight">
                <v-icon v-if="sm > getWindowWidth"> mdi-plus </v-icon>
                <span v-if="sm <= getWindowWidth">{{$t('assets-page-add-device')}}</span>
              </v-btn>
              <v-btn height="32" width="50" min-width="50" :depressed="true" class="primary--text font-weight-bold ml-3 p-0 action-popup-group-category" color="primaryLight">
                <actions-popup-component id="assets-options" :closeDelay="'150'" :iconColor="'var(--v-primary-base)'" :actions="addGroupCategoryBtns"/>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <SummaryView v-if="isSummaryViewSelected" @updateFilters="updateFilters"></SummaryView>
        <!-- Grid component -->
        <DataTable
          v-show="isListViewSelected"
          :visible="isListMapViewSelected"
          :settings="settings"
          :resizeRef="$refs.assets"
          name="assets"
          :columns="columnDefs"
          :rows="tagsDebug"
          :totalRows="filteredTotalRows"
          :page="pagination.page"
          :pageSize="pagination.size"
          :confirmDeleteModalBody="'delete-asset-selection'"
          :confirmDeleteModalTitle="'delete-asset-selection-title'"
          :customTableContainerClass="getIsMobileIpadPortrait ? 'withoutFilters' : 'withFilters'"
          :instructions="hideTags"
          @onPaginationChange="onPaginationChange"
          @onSort="onSorting"
          @onDeleteSelection="deleteSelectedAssets"
          @onExport="downloadCsv"
        ></DataTable>
        <!-- view with accordion list and map -->
        <list-map-view
            class="d-block" 
            v-if="isListMapViewSelected"
            :siteId="currentSite.id"
            :mapData="populatedTags"
            :filters="filterString"
            :showSingleTag="showSingleTag"
            :onlyMap="getIsMobileIpadPortrait ? true : false"
            :totalRows="filteredTotalRows"
            :mapPagination="mapPagination"
            :mapLocations="locations"
            :actions="settings.moreActions"
            :noGeoJsonCall="noGeoJsonCall"
            @loadMore="loadMoreTags"
            @refreshTags="reloadTags">
        </list-map-view>
      </v-col>
    </v-row>
    <site-label-edit ref="siteLabelEditModal" @labelsEdited="setLabels(currentSite)"/>
    <import-device-modal @finished="refreshTags" @upload-started="handleUploadStarted" @upload-complete="handleUploadComplete" @upload-failed="handleUploadFailed" ref="importDeviceModal"/>
    <new-edit-device-modal @editModalMode="createEditMode = 'edit'" @finished="refreshTags" :modalMode="createEditMode" ref="newEditDeviceModal"/>
    <new-edit-category-modal @finished="refreshTags" :modalMode="createEditMode" ref="newEditCategoryModal"/>
    <new-edit-group-modal @finished="refreshTags" :modalMode="createEditMode" ref="newEditGroupModal"/>
    <delete-confirmation-dialog
      v-model="confirmationDeleteDialog"
      :resource-type="deleteResourceType"
      :resource-identifier="deleteResourceIdentifier"
      :resource-name="deleteResourceName"
      @confirm="confirmDelete"
      @cancel="cancelDelete"
    />
  </div>
</template>
<script>

import { mapActions, mapGetters, mapMutations } from 'vuex'
import ListMapView from "../components/assets-map-view/assets-map-view"
import Af3MapView from "../components/assets-af3-map-view/assets-af3-map-view"
import SummaryView from "../components/assets-summary/assets-summary";
import SearchBar from "../components/search-bar/search-bar"
import constants from '../constants/resolutions-constants'
import { pageSize } from '../constants/pagination'
import { pageSizeAF3 } from '../constants/pagination'
import { csvMixin } from "../mixins/csvExport"
import { supertagTok } from '../constants/supertag';
import { AF3_INVALID_COORDINATES } from '../constants/not-applicable-values';
import AssetModel from "../models/tag"
import ImportDeviceModal from "../components/assets/import-device"
import NewEditDeviceModal from "../components/assets/device-new-edit"
import NewEditGroupModal from "../components/assets/group-new-edit" 
import NewEditCategoryModal from "../components/assets/category-new-edit" 
import DataTable from "../components/shared/data-table/data-table.vue"
import FilterForm from "../components/shared/filter-form/filter-form.vue"
import FiltersSaved from "../components/shared/filter-form/filters-saved.vue"
import BatteryLevelComponent from "../components/shared/data-table/custom-cells/battery-level"
import LocationBeaconCellComponent from "../components/shared/data-table/custom-cells/location-beacon-cell"
import LastEventCellComponent from "../components/shared/data-table/custom-cells/last-event-cell"
import LastLocationCellComponent from "../components/shared/data-table/custom-cells/last-location-cell"
import AccessDeviceCellComponent from "../components/shared/data-table/custom-cells/access-device-cell"
import AvailabiltyComponent from "../components/shared/data-table/custom-cells/availability-preview"
import ActionsPopupComponent from "../components/shared/data-table/custom-cells/actions-popup"
import SiteLabelEdit from '../components/sites/site-label-edit'
import TagIcons from '../components/shared/tag-icons/tag-icons.vue'
import DeleteConfirmationDialog from '../components/common/DeleteConfirmationDialog'
import { ROLES } from '../constants/roles';
import { toNodeAddressHex } from '../utils/nodeAddress';
const emptyAssetsSites = []

export default {
  name: "Assets",
  components: {
    DataTable,
    FilterForm,
    FiltersSaved,
    AvailabiltyComponent,
    BatteryLevelComponent,
    LocationBeaconCellComponent,
    LastEventCellComponent,
    LastLocationCellComponent,
    AccessDeviceCellComponent,
    ActionsPopupComponent,
    SiteLabelEdit,
    ImportDeviceModal,
    NewEditDeviceModal,
    NewEditGroupModal,
    NewEditCategoryModal,
    ListMapView,
    Af3MapView,
    SummaryView,
    SearchBar,
    DeleteConfirmationDialog
  },
  data() {
    return {
      columnDefs: null,
      favFilters: [],
      activeFilter: null,
      sm: constants.IPAD_LANDSCAPE,
      iphone: constants.IPHONE_8_PLUS_LANDSCAPE,
      createEditMode: "create",
      confirmationDeleteDialog: false,
      deviceToDelete: null,
      deleteResourceType: 'tag',
      deleteResourceIdentifier: null,
      deleteResourceName: '',
      addGroupCategoryBtns: [
        {
          name: this.$i18n.t('devices-page-export-all'),
          fn: this.exportAll,
          icon: 'file-download-outline'
        },
        {
          name: this.$i18n.t('devices-page-add-group'),
          reference: 'addGroup',
          fn: this.addGroup,
          icon: 'table-plus'
        },
        {
          name: this.$i18n.t('devices-page-edit-group'),
          reference: 'editGroup',
          fn: this.editGroup,
          icon: 'table-edit'
        },
        {
          name: this.$i18n.t('devices-page-delete-group'),
          reference: 'deleteGroup',
          fn: this.deleteGroup,
          icon: 'table-minus'
        },
        {
          name: this.$i18n.t('devices-page-add-category'),
          reference: 'addCategory',
          fn: this.addCategory,
          icon: 'briefcase-plus-outline'
        },
        {
          name: this.$i18n.t('devices-page-edit-category'),
          reference: 'editCategory',
          fn: this.editCategory,
          icon: 'briefcase-edit-outline'
        },
        {
          name: this.$i18n.t('devices-page-delete-category'),
          reference: 'deleteCategory',
          fn: this.deleteCategory,
          icon: 'briefcase-minus-outline'
        }
      ],
      settings: {
            actionsPanel: true,
            sorting: true,
            moreActions: []
          },
      pagination: {
        size: pageSize,
        page: 1
      },
      mapPagination: {
        size: pageSize,
        page: 1
      },
      noPagination: false, //no pagination for indoor tags
      filterString: '',
      sorting: '',
      newSorting: false,
      searchText: '',
      showSingleTag: null,
      cleanForm: false,
      cleanText: false,
      searchTerm: '',
      filterApplied: false,
      toggleOption: 1,
      tabOptions: {
        summary: { id: 0 },
        list: { id: 1 },
        listMap: { id: 2 },
      },
      selectedTab: 1,
      supertagToken: supertagTok,
      noGeoJsonCall: false,
      hideTags: false,
      filterAreaCategory: null,
      isUploadProcessing: false,
    };
  },
  mixins: [csvMixin],
  watch: {
    async currentSite(newSite, oldSite) {
      if (newSite && oldSite && newSite.id === oldSite.id) {
        return;
      }
      this.noGeoJsonCall = false;
      
      this.getColumnDefs();
      if (newSite.isAf3) {
        this.selectedTab = 2;
        this.toggleOption = 2;
        this.pagination = {
        size: pageSizeAF3,
        page: 1
        },
        this.mapPagination = {
          size: pageSizeAF3,
          page: 1
        }
      } else {
        this.pagination = {
          size: pageSize,
          page: 1
        },
        this.mapPagination = {
          size: pageSize,
          page: 1
        }
      }
      this.clearArea();
      this.$refs.filterFormRef && this.$refs.filterFormRef.clearForm();
      this.setLabels(newSite);
      await this.setResetTags('true');
      if(!emptyAssetsSites.includes(this.currentSite.id)){
        if(this.currentSite.isAf3){
          this.noGeoJsonCall = true;
          await this.fetchFilters(); //if we are on map view we need the areas to select one of them
        }else{
          this.fetchFilters();
        }
        await this.initTags(newSite.id);
        this.hideTags = false;
      }else{
        this.fetchFilters();
        this.setTags([]);
        this.setFilteredTotal(0);
        this.hideTags = true;
      }
      // this.favFilters = [];
      this.loadFavFiltersFromStorage();
      this.activeFilter = null;
      if (this.isListMapViewSelected && newSite.isAf3) {
        this.setAf3AreaFilter();
      }
      this.getActionBtns();
    },
    currentArea(newArea, oldArea) {
      if (newArea && oldArea && newArea.id === oldArea.id) {
        return;
      }
      this.getColumnDefs();
    },
    noPagination(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getColumnDefs();
    },
    getIsMobileIpadPortrait: function (value) {
      this.setMoreActionsSIAB(value);
    },
    async selectedTab(newValue) {
      this.setMoreActionsSIAB(this.getIsMobileIpadPortrait);
      // Check if Site is Hurley and Total Number of Tags in Site is undefined
      // This means this is a first load
      if (newValue && 
        newValue === this.tabOptions.listMap.id && 
        emptyAssetsSites.includes(this.currentSite.id) && 
        !this.totalRows) {
          await this.initTags(this.currentSite.id);
          this.hideTags = false;
      }
    },
  },
  computed: {
      ...mapGetters('tag', ['tags', 'populatedTags', 'totalRows', 'filteredTotalRows', 'filters', 'getResetTags']),
      ...mapGetters('area', ['areas', 'currentArea']),
      ...mapGetters('site', ['currentSite', 'sitesLoaded']),
      ...mapGetters('site', { siteUserRole: 'userRole' }),
      
      tagsDebug() {
        return this.tags.map((tag) => ({
          ...tag,
          nodeAddressHex: toNodeAddressHex(tag.id) || null,
          canShowDeviceDashboard: !!this.currentSite.isDeviceDashboardEnable,
        }));
      },
      ...mapGetters('location', ['locations']),
      ...mapGetters('organization', ['getIsIndividualUser']),
      ...mapGetters('organization', { orgUserRole: 'userRole'}),
      ...mapGetters('organization', ['currentOrganization']),
      ...mapGetters('layout', ['getWindowWidth', 'getIsMobileIpadPortrait', 'isSidebarMini']),
      
    currentViewIcon() {
      if (this.isSummaryViewSelected) return 'mdi-chart-bar';
      if (this.isListViewSelected) return 'mdi-format-list-bulleted';
      if (this.isListMapViewSelected) return 'mdi-map';
      return 'mdi-menu';
    },
    currentViewLabel() {
      if (this.isSummaryViewSelected) return this.$t('btn-header-option3');
      if (this.isListViewSelected) return this.$t('btn-header-option1');
      if (this.isListMapViewSelected) return this.$t('btn-header-option2');
      return 'Menu';
    },
      
      filtersWidth: function (){
        return this.isSidebarMini ? (this.getWindowWidth < this.iphone) ? this.getWindowWidth - 330 : (this.sm >= this.getWindowWidth) ? this.getWindowWidth - 380 : this.getWindowWidth - 562 : this.getWindowWidth - 735
      },
      mapFiltersLoaded: function() {
        let zones = this.filters.find(f => f.field === "zoneName");
        let areas = this.filters.find(f => f.field === "areaId");
        let locations = this.filters.find(f => f.field === "locationName");
        return zones && zones.optionsLoaded && areas && areas.optionsLoaded && location && locations.optionsLoaded;
      },
      isSummaryViewSelected: function() {
        return this.selectedTab === this.tabOptions.summary.id;
      },
      isListViewSelected: function() {
        return this.selectedTab === this.tabOptions.list.id;
      },
      isListMapViewSelected: function() {
        return this.selectedTab === this.tabOptions.listMap.id;
      },
      percentFilter(){
        let result = 0;
        if(this.totalRows != 0){
          result = Math.round((this.filteredTotalRows * 100)/this.totalRows);
        }
        return result + "%";
      },
	},
  beforeMount() {
    this.getColumnDefs();
    this.getActionBtns();
  },
  async mounted() {
    // Keep Assets URL clean: default subview comes from preferences, not a query param.
    // If a legacy deep link includes `view`, remove it without affecting real filter params.
    if (this.$route && this.$route.query && this.$route.query.view) {
      const { view, ...rest } = this.$route.query;
      this.$router.replace({ path: '/assets', query: rest });
    }
    this.applyAssetsSubviewFromRoute();
    if(this.currentSite && this.currentSite.id) {
      if (this.currentSite.isAf3) {
        this.pagination = {
          size: pageSizeAF3,
          page: 1
        },
        this.mapPagination = {
          size: pageSizeAF3,
          page: 1
        }
      }
      await this.setResetTags(true);
      if(!emptyAssetsSites.includes(this.currentSite.id)){
        await this.initTags(this.currentSite.id);
        this.hideTags = false;       
      }else{
        this.setTags([]);
        this.setFilteredTotal(0);
        this.hideTags = true;
      }
      this.fetchFilters();
      this.setLabels(this.currentSite);
    }
    this.setMoreActionsSIAB(this.getIsMobileIpadPortrait);
    this.loadFavFiltersFromStorage();
  },
  
  methods: {
    ...mapActions('area', ['setCurrentArea', 'getAreas']),
    ...mapActions('site', ['getSites']),
    ...mapActions('tag', ['getTags', 'getTagsFilters', 'clearFilters', 'deleteTag', 'exportAllTags', 'deleteTags']),
    ...mapActions('header', ['toggleMapVisible']),
    ...mapActions('zone', ['getZones', 'getZoneCategories']),
    ...mapActions('location', ['getLocationsBySite']),
    ...mapActions('supertag', ['setSupertagForSettings']),
    ...mapMutations('tag', ['setResetTags', 'clearMapTags', 'setAreaFilters', 'setLocationFilters', 'setZoneFilters', 'setZoneCategoryFilters', 'setTags', 'setFilteredTotal']),
    ...mapMutations('area', ['resetCurrentArea', 'clearArea']),

    updateFilters(filters){
      if (filters) {
        this.filterAreaCategory = filters;
        }
    },

    applyAssetsSubviewFromRoute() {
      const defaultHomePage = this.$store.getters['preferences/defaultHomePage'];
      if (defaultHomePage === 'assets/map') {
        this.showSingleTag = null;
        this.selectedTab = this.tabOptions.listMap.id;
        this.toggleOption = this.tabOptions.listMap.id;
      } else if (defaultHomePage === 'assets/summary') {
        this.selectedTab = this.tabOptions.summary.id;
        this.toggleOption = this.tabOptions.summary.id;
      } else {
        this.selectedTab = this.tabOptions.list.id;
        this.toggleOption = this.tabOptions.list.id;
      }
    },

    isIndoorTag(tag) {
      return !this.supertagToken.includes(tag.appTok);
    },

    stInIndoorTag(tag) {
      if (this.supertagToken.includes(tag.appTok)) {
        if (tag.locationTime && tag.latitudeTime) {
          if (tag.locationTime > tag.latitudeTime) {
            return true;
          }
        } else if (tag.locationTime) {
          return true;
        }
      }
      return false;
    },

    isOutdoorTag(tag) {
      if (tag && tag.isLeashTag) {
        return true;
      }
      return !this.isIndoorTag(tag) && !this.stInIndoorTag(tag);
    },
    loadFavFiltersFromStorage() {
      try {
        if (!this.currentSite || !this.currentSite.id) {
          this.favFilters = [];
          return;
        }
        
        const storageKey = `favFilters_${this.currentSite.id}`;
        const storedFilters = localStorage.getItem(storageKey);
        if (storedFilters) {
          // NEX-9354 (AC3): entries written before this fix can still carry the
          // transient `selected` flag. Drop it on load so a restored chip never
          // renders as selected while activeFilter is null. Favorites always come
          // back deselected; nothing is auto-applied.
          this.favFilters = JSON.parse(storedFilters).map((favFilter) => {
            const normalized = Object.assign({}, favFilter);
            delete normalized.selected;
            return normalized;
          });
        } else {
          this.favFilters = [];
        }
      } catch (error) {
        console.error('Error loading favorite filters from localStorage:', error);
        this.favFilters = [];
      }
    },

    saveFavFiltersToStorage() {
      try {
        if (!this.currentSite || !this.currentSite.id) {
          return;
        }
        
        const storageKey = `favFilters_${this.currentSite.id}`;
        // NEX-9354 (AC3): `selected` is transient chip UI state, not part of the saved
        // filter. Persisting it made a restored chip render active while activeFilter
        // was null, so the next click on that already-highlighted chip silently
        // replaced "Save to favorites" with "Save & apply" for no visible reason.
        const filtersToPersist = this.favFilters.map((favFilter) => {
          const persistable = Object.assign({}, favFilter);
          delete persistable.selected;
          return persistable;
        });
        localStorage.setItem(storageKey, JSON.stringify(filtersToPersist));
      } catch (error) {
        console.error('Error saving favorite filters to localStorage:', error);
      }
    },

    getActionBtns(){
      //check user role (Admin SiteUser or Admin OrgUser or SuperAdmin)
      if((this.orgUserRole && (this.orgUserRole.assetInfo.metadata.props.role === ROLES.ADMIN || this.orgUserRole.assetInfo.metadata.props.role === ROLES.SUPER_ADMIN))
       || (this.siteUserRole && this.siteUserRole.assetInfo.metadata.props.Admin === 'true')){
         if(!this.addGroupCategoryBtns.find( item => item.reference === 'editLabels')){
            this.addGroupCategoryBtns.splice(1, 0, {
                name: this.$i18n.t('edit-site-labels'),
                reference: 'editLabels',
                fn: this.editLabels,
                icon: 'label-outline'
            });
         }
      } else {
        const item = this.addGroupCategoryBtns.find( item => item.reference === 'editLabels');
        if(item){
          const index = this.addGroupCategoryBtns.indexOf(item);
          this.addGroupCategoryBtns.splice(index, 1);
        }
      }
    },

    getColumnDefs(){
      //define columns, TODO this can be loaded dynamically from JSON since it will come from a service in the future
      this.columnDefs = [
        {
          name: this.$i18n.t('assets-column-name'),
          field: "name",
          type: "render",
          cellRenderer: TagIcons,
          width: "15%"
        },
        { 
          name: this.$i18n.t('assets-column-area'), 
          field: "areaName", 
          type: "data"
        }, 
        { 
          name: this.$i18n.t('assets-column-zone'), 
          field: "zoneName",
          type: "data"
        },
        { 
          name: this.$i18n.t('assets-column-last-event'), 
          field: "lastEventTime",
          type: "render",
          cellRenderer: LastEventCellComponent
        },
        {
          name: this.$i18n.t('assets-column-last-location'),
          field: "lastLocationTime",
          type: "render",
          cellRenderer: LastLocationCellComponent
        },
        {
          name: this.$i18n.t('assets-column-access-device'),
          field: "accessDeviceName",
          sortField: "locationName",
          type: "render",
          cellRenderer: AccessDeviceCellComponent
        },
        { 
          name: this.$i18n.t('assets-column-category'), 
          field: "categoryName",
          type: "data"
        },
        { 
          name: this.$i18n.t('assets-column-group'), 
          field: "groupName",
          type: "data"
        },
        { 
          name: this.$i18n.t('assets-column-field1'), 
          field: "field1",
          type: "data"
        },
        { 
          name: this.$i18n.t('assets-column-field2'), 
          field: "field2",
          type: "data"
        },
        {
          name: this.$i18n.t('assets-column-battery'),
          field: "batteryPriority",
          type: "render",
          cellRenderer: BatteryLevelComponent
        },
      ];
      if(!this.currentSite.isAf3){
        this.columnDefs.splice(3, 0,  { 
          name: this.$i18n.t('assets-column-location'), 
          field: "locationName",
          type: "render",
          cellRenderer: LocationBeaconCellComponent
        });
      }
      const isIndoorArea =
        this.currentArea &&
        this.currentArea.assetInfo &&
        this.currentArea.assetInfo.metadata &&
        this.currentArea.assetInfo.metadata.props &&
        this.currentArea.assetInfo.metadata.props.areaLocation &&
        this.currentArea.assetInfo.metadata.props.areaLocation.toLowerCase() === 'indoor';

      if(this.currentSite && this.currentSite.isGoogleMapsRedirectEnabled && !isIndoorArea){
        this.columnDefs.splice(this.columnDefs.length - 1, 0,  { 
          name: this.$i18n.t('assets-column-gmap'), 
          type: "gmap",
          field: 'gmap',//it is for the header class used on the column order and size
          latField: "latitude",
          lngField: "longitude",
          showIf: (row) => this.isOutdoorTag(row)
        });
      }
      if(localStorage.getItem('tableWidthassets') && (JSON.parse(localStorage.getItem('tableWidthassets')).length !== this.columnDefs.length)){
        localStorage.removeItem('tableWidthassets');
      }
    },
    async setAf3AreaFilter() {
      console.log("setAf3AreaFilter");
      
      // Verify if filterFormRef is available
      if (!this.$refs.filterFormRef) {
        console.warn("filterFormRef is not available");
        this.selectedTab = this.tabOptions.listMap.id;
        return;
      }

      // Verify if there is an area filter
      const hasAreaFilter = this.$refs.filterFormRef.filterString && 
                          this.$refs.filterFormRef.filterString.includes('areaId');
      
      if (!hasAreaFilter) {
        try {
          // Search for the first tag with area
          let firstTagWithArea = this.tags.find(tag => tag.area && tag.area.id);
          
          // If no tag with area is found, use the first available tag
          if (!firstTagWithArea && this.tags.length > 0) {
            firstTagWithArea = this.tags[0];
          }

          if (firstTagWithArea && firstTagWithArea.area) {
            // Verify if filterForm exists
            if (!this.$refs.filterFormRef.filterForm) {
              this.$refs.filterFormRef.filterForm = {};
            }
            
            // Set the area in the form
            this.$refs.filterFormRef.filterForm.areaId = firstTagWithArea.area.id;
            
            // Update the filter string
            const areaFilter = '&areaId=eq:' + firstTagWithArea.area.id;
            this.$refs.filterFormRef.filterString = 
              (this.$refs.filterFormRef.filterString || '') + 
              (this.$refs.filterFormRef.filterString.includes('areaId=') ? 
                '' : areaFilter);
              
            // Apply the filters
            await this.applyFilters({
              filterForm: this.$refs.filterFormRef.filterForm,
              filterString: this.$refs.filterFormRef.filterString
            });
          }
          
          // Change to the map tab
          this.selectedTab = this.tabOptions.listMap.id;
        } catch (error) {
          console.error("Error en setAf3AreaFilter:", error);
          // In case of error, hide the filter menu if it exists
          if (this.$refs.filterFormRef) {
            this.$refs.filterFormRef.menu = false;
          }
          // Change to the map tab anyway
          this.selectedTab = this.tabOptions.listMap.id;
        }
      } else {
        // If there is already an area filter, just change to the map tab
        this.selectedTab = this.tabOptions.listMap.id;
      }
    },
    goToMap() {
      this.showSingleTag = null;
      if (this.currentSite.isAf3 && this.tags[0]) {
        this.setAf3AreaFilter();
      } else {        
        const tabOption = this.tabOptions.listMap.id;
        this.applyFiltersBySummary(tabOption)
      }
    },
    onSummaryTabSelected() {
      this.filterAreaCategory = null;
      if(!this.currentSite.isAf3) {

        this.$refs.filterFormRef && this.$refs.filterFormRef.clearForm();
        
        this.clearAreaFilters();
      }
      this.selectedTab = this.tabOptions.summary.id;
    },

    async clearAreaFilters(){
      this.clearArea();
      await this.setResetTags('true');
    },

    async applyFiltersBySummary(tabOption) {
      console.log("applyFiltersBySummary", tabOption);
      
      // Initialize filterForm and filterString with default values
      let filterForm = {};
      let filterString = '';
      
      // If we have the filter component, use its values
      if (this.$refs.filterFormRef) {
        filterForm = { ...(this.$refs.filterFormRef.filterForm || {}) };
        filterString = this.$refs.filterFormRef.filterString || '';
      }
      
      // Apply additional filters if they exist
      if (this.filterAreaCategory) {
        if (this.filterAreaCategory.areaId) {
          filterForm.areaId = this.filterAreaCategory.areaId;
          filterString += filterString.includes('areaId=') ? 
            filterString.replace(/&?areaId=eq:[^&]*/, '&areaId=eq:' + this.filterAreaCategory.areaId) :
            '&areaId=eq:' + this.filterAreaCategory.areaId;
        }

        if (this.filterAreaCategory.zoneName) {
          filterForm.zoneName = this.filterAreaCategory.zoneName;
          filterString += filterString.includes('zoneName=') ?
            filterString.replace(/&?zoneName=eq:[^&]*/, '&zoneName=eq:' + this.filterAreaCategory.zoneName) :
            '&zoneName=eq:' + this.filterAreaCategory.zoneName;
        }
        
        if (this.filterAreaCategory.categoryName) {
          filterForm.categoryName = this.filterAreaCategory.categoryName;
          filterString += filterString.includes('categoryName=') ?
            filterString.replace(/&?categoryName=eq:[^&]*/, '&categoryName=eq:' + this.filterAreaCategory.categoryName) :
            '&categoryName=eq:' + this.filterAreaCategory.categoryName;
        }
      
        if (this.filterAreaCategory.groupName) {
          filterForm.groupName = this.filterAreaCategory.groupName;
          filterString += filterString.includes('groupName=') ?
            filterString.replace(/&?groupName=eq:[^&]*/, '&groupName=eq:' + this.filterAreaCategory.groupName) :
            '&groupName=eq:' + this.filterAreaCategory.groupName;
        }            
      }

      // Apply the filters
      await this.applyFilters({ filterForm, filterString });
      this.selectedTab = tabOption;         
    },

    onListTabSelected() {
      const tabOption = this.tabOptions.list.id;
      this.applyFiltersBySummary(tabOption);
    },
    async loadAllTags(){
      await this.initTags(this.currentSite.id);
      this.fetchFilters();
      this.hideTags = false;
    },
    createDevice() {
      this.createEditMode = 'create';
      this.$refs.newEditDeviceModal.openModal();
    },
    setMoreActionsSIAB(isSIAB) {
      const openMapAction = {
        name: this.$i18n.t('assets-open-map'),
        fn: this.openMap,
        icon: 'map-marker-radius',
        enabledIf: ['canOpenInMap']
      };

      const deviceDetailAction = {
        name: this.$i18n.t('device-detail-btn'),
        fn: this.goToDeviceDetail,
        icon: 'view-dashboard',
        enabledIf: ['nodeAddressHex', 'canShowDeviceDashboard'],
      };

      if (isSIAB) {
        this.settings.moreActions = [
          ...(!this.isListMapViewSelected ? [openMapAction] : []),
          {
            name: this.$i18n.t('table-edit'),
            fn: this.editDevice,
            icon: 'pen'
          },
          deviceDetailAction,
        ]
      } else {
        this.settings.moreActions = [
          ...(!this.isListMapViewSelected ? [openMapAction] : []),
          {
            name: this.$i18n.t('table-edit'),
            fn: this.editDevice,
            icon: 'pen'
          },
          {
            name: this.$i18n.t('sidebar-supertag-settings'),
            fn: this.openSTSettings,
            icon: 'cog',
            condition: { 
              field: 'appTok',
              operator: 'CONTAINS',
              value: this.supertagToken
            }
          },
          deviceDetailAction,
          {
            name: this.$i18n.t('table-delete'),
            fn: this.delete,
            icon: 'delete'
          }
        ]
      }
    },
    goToDeviceDetail(asset) {
      const hex = asset.nodeAddressHex || toNodeAddressHex(asset.id);
      if (!hex) return;
      this.$router.push({ name: 'device-detail', params: { nodeAddressHex: hex }, query: { name: asset.name } });
    },
    searchTyped(text) {
      this.searchTerm = text;
    },
    importDevice(){
      this.$refs.importDeviceModal.openModal();
    },    
    handleUploadStarted() {
      this.isUploadProcessing = true;
    },    
    handleUploadComplete(resp) {
      this.isUploadProcessing = false;
      this.refreshTags();
    },    
    handleUploadFailed() {
      this.isUploadProcessing = false;
    },
  
    editDevice(asset) {
      this.createEditMode = 'edit';
      this.$refs.newEditDeviceModal.openModal(asset);
    },
    delete(asset) {      
      this.deviceToDelete = asset;
      this.deleteResourceType = 'tag';
      this.deleteResourceIdentifier = asset.id;
      this.deleteResourceName = asset.name;
      this.confirmationDeleteDialog = true;
    },
    openSTSettings(tag){
      this.setSupertagForSettings(tag);
      this.$router.push('/devices/settings');
    },
    openMap(asset){
      this.showSingleTag = [asset];
      this.selectedTab = this.tabOptions.listMap.id;
      this.toggleOption = this.tabOptions.listMap.id;
    },
    async deleteSelectedAssets(assets) {
      this.deviceToDelete = assets;
      this.deleteResourceType = 'tag';
      this.deleteResourceIdentifier = assets.map(a => a.id);
      this.deleteResourceName = '';
      this.confirmationDeleteDialog = true;
    },
    async confirmDelete() {
      if (Array.isArray(this.deviceToDelete)) {
        let devices = {
          nodeAddresses: [],
          siteId: this.currentSite.id
        };
        try {
          this.deviceToDelete.forEach(asset => {
            devices.nodeAddresses.push(asset.id);
          });
          await this.deleteTags({devices});
          this.$toasted.show(this.deviceToDelete.length + ' ' + this.$t('devices-page-devices-deleted'), { 
            position: "bottom-right",
            className: ['toast-success'], 
            action : {
                text : this.$t('devices-page-ok'),
                onClick : (e, toastObject) => {
                    toastObject.goAway(0);
                }
              },
          });
          this.confirmationDeleteDialog = false;
          this.deviceToDelete = null;
          this.refreshTags();
        } catch (error) {
          this.$toasted.show(error, { 
            position: "bottom-right",
            className: ['toast-error'], 
            duration : 5000
          });
          this.confirmationDeleteDialog = false;
          this.deviceToDelete = null;
          this.refreshTags();
        }
      } else {
        let device = {
          nodeAddress: this.deviceToDelete.id,
          siteId: this.currentSite.id
        };
        try {
          let resp = await this.deleteTag({ device });
          this.$toasted.show(this.$t('devices-page-device-deleted'), { 
            position: "bottom-right",
            className: ['toast-success'], 
            duration : 1500
          });
          this.confirmationDeleteDialog = false;
          this.deviceToDelete = null;
          this.refreshTags();
        } catch (error) {
          this.$toasted.show(error, { 
            position: "bottom-right",
            className: ['toast-error'], 
            duration : 5000
          });
          this.confirmationDeleteDialog = false;
          this.deviceToDelete = null;
          this.refreshTags();
        }
      }
    },
    cancelDelete() {
      this.confirmationDeleteDialog = false;
      this.deviceToDelete = null;
      this.deleteResourceIdentifier = null;
      this.deleteResourceName = '';
    },  
    setLabels(site) {
      let labels = site?.assetInfo?.metadata?.props?.labels;
      if (labels) {
        this.columnDefs.map((col) => {
          switch (col.field) {
            case 'name':
              col.name = labels.tag;
              break;
            case 'categoryName':
              col.name = labels.category;
              break;
            case 'groupName':
              col.name = labels.group;
              break;
            case 'field1':
              col.name = labels.field1;
              break;
            case 'field2':
              col.name = labels.field2;
              break;
            default:
              break;
          }
        })
        this.addGroupCategoryBtns.map((btn) => {
          switch (btn.reference) {
            case 'addGroup':
              btn.name = this.$i18n.t('add') + ' ' + labels.group;
              break;
            case 'editGroup':
              btn.name = this.$i18n.t('edit') + ' ' + labels.group;
              break;
            case 'deleteGroup':
              btn.name = this.$i18n.t('delete') + ' ' + labels.group;
              break;
            case 'addCategory':
              btn.name = this.$i18n.t('add') + ' ' + labels.category;
              break;
            case 'editCategory':
              btn.name = this.$i18n.t('edit') + ' ' + labels.category;
              break;
            case 'deleteCategory':
              btn.name = this.$i18n.t('delete') + ' ' + labels.category;
              break;
            default:
              break;
          }
        })        
      }
    },
    refreshTags() {  
      if (!this.isUploadProcessing) {
        this.reloadTags(this.currentSite.id, true);
      }
    },
    onSorting(sorting){
      this.newSorting = true;
      this.sorting = sorting;
      this.pagination.page = 1;
      this.reloadTags(this.currentSite.id);
    },
    saveFilterToFav(newFilter) {
      // adds a filter to filters array
      let filter = this.favFilters.filter( f => f.id === newFilter.id );
      if(!filter.length){
        this.$set(this.favFilters, this.favFilters.length, newFilter);
        //call endpoint to save the new filter
      }else{
        Object.assign(filter[0], newFilter);
        //call endpoint to update the filter
      }
      this.saveFavFiltersToStorage();
    },
    applyFavFilter(filter) {
      //load the filter form
      this.activeFilter = filter;
      //call endpoint to get the filterd data
    },
    deleteFavFilter(id) {
      // removes a filter from filters array
      this.favFilters = this.favFilters.filter( filter => filter.id !== id );
      this.saveFavFiltersToStorage();      
    },
    async applyFilters(filter) {
  console.log('🔍 [FILTER] applyFilters called with:', filter);
  console.log('🔍 [FILTER] Current org:', this.$store.getters['organization/currentOrganization']?.id);
  
  if(filter.filterForm && filter.filterForm.areaId){
    await this.setCurrentArea({areaId: filter.filterForm.areaId});
    if(this.currentArea.assetInfo && this.currentArea.assetInfo.metadata.props.areaLocation.toLowerCase() === 'indoor'){
      this.noPagination = true;
    }else{
      this.noPagination = false;
    }
  }else{   
    //reset it just if previous filter has setted it
    if(this.filterString.includes('areaId')){
      await this.resetCurrentArea();
    }
    this.noPagination = false;
  }
  this.noGeoJsonCall = false;
  this.searchText = '';
  this.filterString = filter.filterString;
  console.log('🔍 [FILTER] filterString set to:', this.filterString);
  
  this.resetPagination();
  await this.setResetTags(true);
  
  console.log('🔍 [FILTER] About to call reloadTags...');
  try {
    await this.reloadTags(this.currentSite.id);
    console.log('✅ [FILTER] reloadTags completed successfully');
  } catch (error) {
    console.error('❌ [FILTER] reloadTags failed:', error);
    throw error;
  }
  
  this.hideTags = false;
  if(this.filterString){
    this.filterApplied = true;
  }else{
    if(!this.searchText){
      this.filterApplied = false;
    }
  }
},
    deselectFavFilter(filterId){
      let filter = this.favFilters.filter( f => f.id === filterId);
      filter[0].selected = false;
      this.activeFilter = null;
      this.$refs.favFilters.deselectFilter();
    },
    async searchBarFilter(text){
      await this.setResetTags(true); //reset grid and list and store the first page for the filtered data
      this.filterString = '';
      if(text){
        this.searchText = '&search='+ text;
        (!this.getIsMobileIpadPortrait) ? this.$refs.filterFormRef.applyFilters() : this.applyFilters({filterString: this.searchText});
        this.filterApplied = true;
      } else {
        this.searchText = '';
        if(!this.getIsMobileIpadPortrait){
          this.$refs.filterFormRef.searchTerm = '';
          this.$refs.filterFormRef.applyFilters();
        }else{
          this.applyFilters({filterString: this.searchText});
        }
      }
    },
    async onPaginationChange(newPagination) {
      if(newPagination.pageSize !== this.pagination.size){
        this.mapPagination.page = 1;
        this.mapPagination.size = newPagination.pageSize;
        this.setResetTags(true);// we need to reset and load page 1 with the new page size
      }
      this.pagination.page = newPagination.page;
      this.pagination.size = newPagination.pageSize;      
      const tags = await this.reloadTags(this.currentSite.id);
    },
    resetPagination() {
      Object.assign(this.pagination, {
        size: this.pagination.size,
        page: 1
      });
      Object.assign(this.mapPagination, {
        size: this.mapPagination.size,
        page: 1
      });
      this.clearMapTags();
    },
    resetFilter() {
      this.filterString = '';
      this.cleanForm = true;
      this.searchText = "";
      this.filterApplied = false;
      this.cleanText = true;
      this.searchTerm = "";
    },
    resetFilterAf3() {
      this.filterString = '';
      this.cleanForm = false;
      this.searchText = "";
      this.filterApplied = false;
      this.cleanText = true;
      this.searchTerm = "";
    },
    clearSearchClicked() {
      if (this.currentSite.isAf3) {
        this.resetFilterAf3();
      } else {
        this.resetFilter();
      }
      if(!this.getIsMobileIpadPortrait){
        this.$refs.filterFormRef.resetSearch();
      }
    },
    async initTags(siteId) {
      this.resetPagination();
      this.resetFilter();

      // NEX-7528 - Get param values from the URL if there are (only real filters)
      const allowedFilterKeys = [
        'areaId',
        'zoneName',
        'zoneCategoryName',
        'locationName',
        'categoryName',
        'groupName',
        'batteryStatus',
        'lastEventFrom',
        'lastEventTo',
        'lastEventTime',
        'search',
      ];

      const routeQuery = (this.$route && this.$route.query) ? this.$route.query : {};
      const filterQuery = {};
      allowedFilterKeys.forEach((key) => {
        if (routeQuery[key] !== undefined && routeQuery[key] !== null && routeQuery[key] !== '') {
          filterQuery[key] = routeQuery[key];
        }
      });

      const hasRouteFilters = Object.keys(filterQuery).length > 0;
      
      // Apply default filter for specific organization
      const targetOrgUuid = 'c1b1e3c9-a825-4b10-a06f-51096bc33ba4';
      const currentOrg = this.$store.getters['organization/currentOrganization'];
      const shouldApplyDefaultFilter = !hasRouteFilters && 
                                      currentOrg && 
                                      currentOrg.id === targetOrgUuid;
      
      if (shouldApplyDefaultFilter) {
        // Apply "less than 4 hours" filter
        const fourHoursAgo = this.$moment.utc().subtract(4, 'hours').format('YYYY-MM-DDTHH:mm:ss');
        const now = this.$moment.utc().format('YYYY-MM-DDTHH:mm:ss');
        
        filterQuery.lastEventFrom = encodeURIComponent(fourHoursAgo);
        filterQuery.lastEventTo = encodeURIComponent(now);
        
        this.filterApplied = true;
        this.$nextTick(() => {
          if (this.$refs.filterFormRef) {
            this.$refs.filterFormRef.filterForm.lastSeen = '4';
            this.$refs.filterFormRef.filterApplied = true;
          }
        });
      
      } else if (hasRouteFilters) {
        this.filterApplied = true;
      }

      const filters = Object.keys(filterQuery).length > 0
        ? Object.keys(filterQuery)
            .map((k) => `&${k}=${filterQuery[k]}`)
            .join('')
        : '';

      try{
        // TODO ADD RESET SORT
        this.newSorting = true;
        this.sorting = "&sortBy=lastEventTime&sort=dsc";
        const tags = await this.reloadTags(siteId, undefined, filters);
        this.cleanText = false;
        this.cleanForm = false;
        return tags;
      }catch(error){
        this.$toasted.show(error, { 
          position: "bottom-right",
          className: ['toast-error'], 
          duration : 5000
        });
        return [];
      }
    },
    async loadMoreTags(pagination){
        this.mapPagination.page = pagination.page;
        await this.reloadTags(this.currentSite.id);
    },
    async reloadTags(siteId, refresh, filters) {
      let params = {
        siteId: siteId,
        refresh: refresh
      }
      //if the user is on Map view, use map pagination
      if(this.isListMapViewSelected && !refresh){//if refresh we need to get tags from grid and list
        params.fromMap = true;
        params.pagination = this.mapPagination;
      }else{ //add the map pagination to get the list tags
        params.pagination = this.pagination;
        params.mapPagination = this.mapPagination;
      }
      if (this.filterString) {
        params.filters = this.filterString.replaceAll("None", null);
      }
      if(filters){
        params.filters = filters;
      }
      if (this.sorting) {
        params.sorting = this.sorting;
        if(this.newSorting){
          params.newSorting = true;
        }
      }
      if(this.searchText){
        params.filters = (params.filters) ? params.filters + this.searchText : this.searchText; 
      }
      if(this.currentArea && this.currentArea.assetInfo && this.currentArea.assetInfo.metadata.props.areaLocation.toLowerCase() === 'indoor'){
        if(this.getResetTags){
          params.indoor = true;
        }
      }
      let tags = await this.getTags(params);
      if(this.newSorting){
        this.newSorting = false;
        this.mapPagination.page = 1;
      }
      return tags;
    },
    async fetchSites() {
      const sites = await this.getSites();
    },
    async fetchFilters() {
      await this.clearFilters();
      this.getTagsFilters({ siteId: this.currentSite.id });
        let areasPromise = this.getAreas({siteId: this.currentSite.id, hiddenLoader: true});
        let zonesPromise = this.getZones({siteId: this.currentSite.id, hiddenLoader: true});
        let zoneCategoryPromise = this.getZoneCategories({siteId: this.currentSite.id, hiddenLoader: true});
        let locationsPromise = this.getLocationsBySite({ siteId: this.currentSite.id, hiddenLoader: true, isAf3: this.currentSite.isAf3});
      try {
        this.setAreaFilters(await areasPromise);
      } catch (error) {
        console.error(error);  
      }
      try {
        this.setZoneFilters(await zonesPromise);
      } catch (error) {
        console.error(error);  
      }
      try {
        this.setZoneCategoryFilters(await zoneCategoryPromise)
      } catch (error) {
        console.error(error);
      }
      try {
        this.setLocationFilters(await locationsPromise);
      } catch (error) {
        console.error(error);  
      }
    },
    editLabels(){
      this.$refs.siteLabelEditModal.openModal(this.currentSite);
    },
    addCategory() {
      this.$refs.newEditCategoryModal.openModal('create');
    },
    editCategory() {
      this.$refs.newEditCategoryModal.openModal('edit');
    },
    deleteCategory() {
      this.$refs.newEditCategoryModal.openModal('delete');
    },
    addGroup() {
      this.$refs.newEditGroupModal.openModal('create');
    },
    editGroup() {
      this.$refs.newEditGroupModal.openModal('edit');
    },
    deleteGroup() {
      this.$refs.newEditGroupModal.openModal('delete');
    },
    downloadCsv(assets) {
      let normalizedAssets = assets.map((asset)=> new AssetModel().normalizeForCsv(asset, this.columnDefs));
      if (normalizedAssets) {
        csvMixin.methods.csvExport(normalizedAssets, 'Assets');
      }
    },
    async exportAll(){
      const filters = this.filterString + this.searchText + this.sorting;
      const siteId = this.currentSite.id;
      const file = await this.exportAllTags({ siteId: siteId, filters: filters});
      csvMixin.methods.downloadFile('AllAssets', file.data);
    }
  }
};
</script>

<style lang="scss" scoped>
  .btn-toggle .v-btn {
    background-color: #fff !important;
    color:var(--v-secondary-base) !important;
  }
  .btn-toggle .v-btn.v-item--active {
    color: #ffffff !important;
    background-color: var(--v-secondary-base) !important;
    .v-icon {
      color: #ffffff !important;
    }
  }
  .show-map-btn.theme--dark.v-btn.v-btn--disabled{
    background-color: lightgray!important;
    span {
      color: #f2f2f2!important;
    }
  }
  .pull-up{
    position: absolute;
    margin-left: 20px;
    z-index: 999;
  }
  .total-text{
    font-size: 0.85rem;
    width: auto;
    float: left;
    margin-top: 9px;
  }
  .right-btn-container {
    height: 100%;
    float: right;
  }
    // dialogs
  .headline {
    height: 48px;
    font-size: 18px !important;
    font-weight: 600;
    color: #3B5762;
  }

  .action-popup-group-category {
    width: 62px;
    margin: 0px;
    button {
      width: 100% !important;
    }
  }

  .only-search {
    max-width: 65%;
    flex: 0 0 90%;
  }

  .filter-height{
    height: 50px;
  }

  .relative-position{
    position: relative;
  }

  .no-sites-msg{
    position: absolute;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: 99;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  //media queries
  @media (max-width: 1365px) {
    .total-text {
      display: none;
    }
  }

  // IE styles
  @media all and (-ms-high-contrast:none) {
    .right-btn-container {
      padding-top: 2px;
    } 
  }
  /* Media query for tablets */
  @media (max-width: 768px) and (min-width: 481px) {
    .only-search {
      max-width: 75%;
      flex: 0 0 75%;
    }
  }

  /* Media query for small mobile devices (like iPhone SE or devices with 360px width) */
  @media (max-width: 360px) {
    .only-search {
      max-width: 50%;
      flex: 0 0 50%;
    }
  }

  /* Media query for standard mobile devices */
  @media (max-width: 480px) and (min-width: 361px) {
    .only-search {
      max-width: 60%;
      flex: 0 0 60%;
  }
}
</style>